export function ConvertErrors422ToString(array) {
  if (!Array.isArray(array)) {
    return '';
  }
  return array.map(err => `${err.field}: ${err.message}`).join('\n');
}